// src/hooks/useContactForm.js
import { useState } from 'react';
import { validateField } from '../services/inputCheck';
import { postContent } from '../services/strapi/endpoints';

const useContactForm = ({setNotification}) => {
    const [values, setValues] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setValues(prev => ({
            ...prev,
            [name]: value
        }));

        // Utilisation de la fonction validateField de inputCheck.js
        const error = validateField(name, value);
        setErrors(prev => ({
            ...prev,
            [name]: error
        }));
    };

    const validateForm = () => {
        const newErrors = {};
        Object.keys(values).forEach(key => {
            const error = validateField(key, values[key]);
            if (error) newErrors[key] = error;
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            setStatus({
                type: 'error',
                message: 'Veuillez corriger les erreurs du formulaire'
            });
            return;
        }

        setIsSubmitting(true);
        try {
            // Exécution de reCAPTCHA v3
            const token = await window.grecaptcha.execute(
                process.env.REACT_APP_RECAPTCHA_SITE_KEY, 
                { action: 'contact_form' }
            );
                        
            /* const response = await api.post('/contact', {
                ...values,
                recaptchaToken: token
            }); */
                            
            const response = await postContent('contact', {
                ...values,
                recaptchaToken: token
            });

            setNotification({
                message: "Ton Message a été envoyé avec succès",
                type: 'success'
            });
            
            // Reset du formulaire
            setValues({
                name: '',
                email: '',
                phone: '',
                message: ''
            });
            setErrors({});

        } catch (error) {
            setNotification({
                message: "Ton Message n'a pas été envoyé",
                type: 'error'
            });
            console.log(error)
            
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        values,
        errors,
        isSubmitting,
        status,
        handleChange,
        handleSubmit
    };
};

export default useContactForm;